var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "18px",
    height: "18px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2C11.24 3.66 9 5.83 9 9.5C9 11.15 9.78 12.54 11.13 13.37C10.42 14.23 10 15.31 10 16.5C10 18.99 12 22 12 22C12 22 14 18.99 14 16.5C14 15.31 13.58 14.23 12.87 13.37C14.22 12.54 15 11.15 15 9.5C15 5.83 12.76 3.66 12 2ZM6 14C6 16 7 18 8 19C8 18 8 17 9 16C7.79 15.11 6 14 6 14ZM18 14C18 14 16.21 15.11 15 16C16 17 16 18 16 19C17 18 18 16 18 14Z",
    fill: "#1F2D3C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeating);
export default __webpack_public_path__ + "static/media/heating.0ac26bfa50a9b1cda13288e10fa5c53d.svg";
export { ForwardRef as ReactComponent };